import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { toast } from "react-toastify";

// IMC credentials
//storageBucket: "imc-patient-portal.firebasestorage.app",
export const firebaseConfig = {
  apiKey: "AIzaSyB4AhUG7DXGOm_cppgfM7AFhN6Ykt4Lq08",
  authDomain: "imc-patient-portal.firebaseapp.com",
  databaseURL: "https://imc-patient-portal.firebaseio.com",
  projectId: "imc-patient-portal",
  storageBucket: "imc-patient-portal.appspot.com",
  messagingSenderId: "138423925179",
  appId: "1:138423925179:web:a853ec900d9a5dbae42c9e",
  vapidKey:
    "BBS-N-UgP6K6GpFI5sgbySo61JERafcdev-1zRuWNOu-6By-A4gDxjwaCC1k1KQ4AqavroFWOVy8bxqSYmCcYy0",
};

// mytest credentials

// export const firebaseConfig = {
//   apiKey: "AIzaSyCFA4Moje181a63e-s6qRPg5l0Y9X6mp1U",
//   authDomain: "reactproject-4a4c9.firebaseapp.com",
//   databaseURL: "https://reactproject-4a4c9-default-rtdb.firebaseio.com",
//   projectId: "reactproject-4a4c9",
//   storageBucket: "reactproject-4a4c9.appspot.com",
//   messagingSenderId: "162060263721",
//   appId: "1:162060263721:web:8ad3eac37f8f7e67f45738",
//   measurementId: "G-1350D6GFVK",
//   serverKey: 'AAAAIDq1ebs:APA91bF84HD8Po6jp8ynjyzsMNOkZJehc4FKcDKw0GtLmAGAUYcH5omMBXQerVtZzV7eCjSw_geahySdZ0KL4hQh27UMk6-fZ8sal2LtDPMtFkVXxBPHVHtjH19Ttqu6mZZb5PN5JQSd',
//   vapidKey:'BAtKCHTlQm84qA6-FistiCxkFvrjrJRDVTiyEwCQuOCOyzgjiIwDQYjbKGlMzpvSaE2_y7xUsHY7loL81HqeNoo'
// };

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

const getFCMWebTokenAndHandleNotifications = async (onNotification) => {
  try {
    const token = await getToken(messaging, {
      vapidKey: firebaseConfig.vapidKey,
    });

    if (token) {
      // Send this token to your server to send notifications
      localStorage.setItem("fcmToken", token);

      // OnMessage event triggers whenever new notifications received
      onMessage(messaging, (payload) => {
        // Trigger a ring or sound
        // const audio = new Audio('/sounds/message_tone.mp3'); // Add a ringtone file to the public folder
        // audio.play();
        // toast(JSON.stringify(payload));
        onNotification && onNotification(payload);
      });
    } else {
      console.log("No registration token available.");
    }
  } catch (error) {
    console.error("Error getting token", error);
  }
};

export { app, messaging, getFCMWebTokenAndHandleNotifications };
